export const CPT_TASK_LOG_FIELD_IDS = {
    taskSummary: 'taskSummary',
    taskTimeline: 'taskTimeline',
    cptCodes: 'cptCodes',
} as const;

export const CPT_TASK_LOG_TONE = 'cpt-task-log' as const;

export type CptViewTone = 'default' | typeof CPT_TASK_LOG_TONE;

export const isCptTaskLogSummaryField = (fieldId?: string): boolean =>
    fieldId === CPT_TASK_LOG_FIELD_IDS.taskSummary;

export const isCptTaskLogTimelineField = (fieldId?: string): boolean =>
    fieldId === CPT_TASK_LOG_FIELD_IDS.taskTimeline;

export const isCptTaskLogCptCodesField = (fieldId?: string): boolean =>
    fieldId === CPT_TASK_LOG_FIELD_IDS.cptCodes;
